<template>
  <div class="columns is-multiline">
    <div v-for="(property, index) in stbyInfo" class="column is-6" v-if="!excludeProperties.includes(index)">
      <span class="heading has-text-grey-dark">{{snakeToCamelCase(index)}}</span>
      <div class="field">
        <bulma-in class="textarea" :name="index" v-model="stbyInfo[index]" rules="" :placeholder="snakeToCamelCase(index)"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'lesson-additional-info',
    components: {},
    props: {
      additionalInfo: { required: true },
    },
    data () {
      return {
        excludeProperties: ['id', 'name', 'words', 'provider_full_id', 'provider_id'],
      }
    },
    created () {
      this.stbyInfo = Object.assign({}, this.additionalInfo)
        console.log(this.additionalInfo);
  },
    methods: {
/*      save () {

        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit('submit', result);
          }
        })
      }*/
    },
    watch: {
        'stbyInfo':function (value) {
            console.log(value);
        }

    }

  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/components/AdditionalInfo.vue